import React from "react";
import { Tabs } from "antd";
import MerchantPOFromSupplier from "./po";
import MerchantDeliveryFromSupplier from "./delivery";
import MerchantLayout from "../../layout/MerchantLayout";
import ReportFiled from "./report-filed/ReportFiled";

const MerchantDelivery = () => {
  const items = [
    {
      key: "1",
      label: `Purchase Order`,
      children: <MerchantPOFromSupplier />,
    },
    {
      key: "2",
      label: `Receiving`,
      children: <MerchantDeliveryFromSupplier />,
    },
    {
      key: "3",
      label: `ReportFiled`,
      children: <ReportFiled />,
    },
  ];

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />
    </MerchantLayout>
  );
};

export default MerchantDelivery;
